// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file nodebase/v1/worker.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import { WorkerService } from "./worker_pb";

/**
 * CreateWorker and DestroyWorker are operator RPCs: worker lifecycle is
 * managed server-side. A user's worker comes from EnsureWorker.
 *
 * @generated from rpc nodebase.v1.WorkerService.CreateWorker
 */
export const createWorker = WorkerService.method.createWorker;

/**
 * EnsureWorker returns the workspace's worker, provisioning one first when
 * none exists. Idempotent; the account-facing way to obtain a worker now
 * that self-serve CreateWorker is operator-only (one worker per user).
 *
 * @generated from rpc nodebase.v1.WorkerService.EnsureWorker
 */
export const ensureWorker = WorkerService.method.ensureWorker;

/**
 * @generated from rpc nodebase.v1.WorkerService.GetWorker
 */
export const getWorker = WorkerService.method.getWorker;

/**
 * @generated from rpc nodebase.v1.WorkerService.ListWorkers
 */
export const listWorkers = WorkerService.method.listWorkers;

/**
 * @generated from rpc nodebase.v1.WorkerService.RegisterWorker
 */
export const registerWorker = WorkerService.method.registerWorker;

/**
 * @generated from rpc nodebase.v1.WorkerService.Heartbeat
 */
export const heartbeat = WorkerService.method.heartbeat;

/**
 * @generated from rpc nodebase.v1.WorkerService.ReportState
 */
export const reportState = WorkerService.method.reportState;

/**
 * ReportTraffic uploads closed egress accounting windows (technical plan
 * §7.6 ③). Delivery is at-least-once; the server dedupes on the window key
 * and acks what it has durably recorded; the agent marks acked windows
 * reported, stops sending them, and keeps the latest of them locally
 * for `nb traffic`.
 *
 * Privacy contract: the per-window destination list exists only in flight.
 * The server merges destinations into global buckets (all workspaces
 * combined) in the same transaction that records the window, and persists no
 * user↔destination pair — the billing ledger keeps byte totals per
 * workspace, the destination stats keep no workspace. This is a product
 * promise, not an implementation detail; changing it requires a docs-level
 * decision (product architecture §4.8).
 *
 * @generated from rpc nodebase.v1.WorkerService.ReportTraffic
 */
export const reportTraffic = WorkerService.method.reportTraffic;

/**
 * @generated from rpc nodebase.v1.WorkerService.DestroyWorker
 */
export const destroyWorker = WorkerService.method.destroyWorker;

/**
 * @generated from rpc nodebase.v1.WorkerService.RebuildWorker
 */
export const rebuildWorker = WorkerService.method.rebuildWorker;
